import { render, staticRenderFns } from "./TagsCategory.vue?vue&type=template&id=208dd7cd&scoped=true&"
import script from "./TagsCategory.vue?vue&type=script&lang=ts&"
export * from "./TagsCategory.vue?vue&type=script&lang=ts&"
import style0 from "./TagsCategory.vue?vue&type=style&index=0&id=208dd7cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208dd7cd",
  null
  
)

export default component.exports